var map = {
	"./lewis-hamilton-feeds-kangaroos.jpg": "ad9b",
	"./logo.png": "cf05",
	"./michelle-obama-medium.jpg": "6fdb",
	"./michelle-obama-small.jpg": "3c24",
	"./michelle-obama.png": "a2d2",
	"./youtubers-for-human-rights-small.jpg": "4c0c",
	"./youtubers-for-human-rights.jpg": "e657"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";